<section class="panel p-4">
  <div class="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
    <h2 class="h5 mb-0">Relogio de ponto</h2>
    <app-seletor-aba-relogio
      [aba]="aba"
      (selecionar)="selecionarAba($event)">
    </app-seletor-aba-relogio>
  </div>

  <app-painel-horarios-relogio
    *ngIf="aba === 'horarios'"
    [empregadores]="empregadores"
    [empregadorSelecionado]="empregadorSelecionado"
    [relogioEmpregador]="relogioEmpregador"
    [jornadas]="jornadas"
    (empregadorSelecionadoChange)="empregadorSelecionadoChange.emit($event)"
    (alterarEmpregador)="alterarEmpregador.emit()"
    (mensagem)="mensagem.emit($event)"
    (relogioSalvo)="relogioSalvo.emit($event)"
    (relogioLimpo)="relogioLimpo.emit($event)"
    (irParaJornadas)="selecionarAba('jornadas')">
  </app-painel-horarios-relogio>

  <div *ngIf="aba === 'jornadas'">
    <app-painel-jornadas-relogio
      [empregadores]="empregadores"
      [empregadorSelecionado]="empregadorSelecionado"
      [jornada]="jornada"
      [jornadas]="jornadas"
      (empregadorSelecionadoChange)="empregadorSelecionadoChange.emit($event)"
      (alterarEmpregador)="alterarEmpregador.emit()"
      (mensagem)="mensagem.emit($event)"
      (jornadaSalva)="jornadaSalva.emit($event)"
      (jornadaLimpa)="jornadaLimpa.emit($event)"
      (jornadaExcluida)="jornadaExcluida.emit()">
    </app-painel-jornadas-relogio>
  </div>

  <div *ngIf="aba === 'terminais'">
    <app-painel-terminais-relogio
      [empregadores]="empregadores"
      [departamentos]="departamentos"
      [empregadorSelecionado]="empregadorSelecionado"
      [terminal]="terminal"
      [terminais]="terminais"
      (empregadorSelecionadoChange)="empregadorSelecionadoChange.emit($event)"
      (alterarEmpregador)="alterarEmpregador.emit()"
      (mensagem)="mensagem.emit($event)"
      (terminalChange)="terminalChange.emit($event)"
      (terminalSalvo)="terminalSalvo.emit($event)"
      (terminalLimpo)="terminalLimpo.emit($event)"
      (terminalRevogado)="terminalRevogado.emit($event)"
      (terminalExcluido)="terminalExcluido.emit()">
    </app-painel-terminais-relogio>
  </div>
</section>
